    

  <div style="text-align: center;">
    <h1> <font color="#005b9d">    <img style="max-width:100%; height:auto;" src="../../../../../assets/images/Premier1.jpg" alt="../../../../../assets/images/premierlogonew.jpg" /> </font></h1>
</div>



<div *ngIf="!hidelogin" >
<div style="text-align: center">
    <h1> <font color="#005b9d"> {{'resetemailpage.TranslationSection.text1' | translate}}</font></h1>
</div>


<form [formGroup]="loginForm" (ngSubmit) = "sendmail(loginForm.value)">
    <p class="text-muted">{{'resetemailpage.TranslationSection.text2' | translate}}</p>

    <div *ngIf="showErrorMessage" class="inline-block">
      <label style="font-size: small;color:#b30000; text-align: left;">{{'resetemailpage.TranslationSection.text7' | translate}}
        </label>

        <a class="nav-link" [routerLink]="['/signup']" value="Sign In" style="color: blue; font-size: small;">{{'resetemailpage.TranslationSection.text4' | translate}}</a>
    </div>
 
 
    <div class="input-group mb-4">
      <div class="input-group-prepend">
        <span class="input-group-text"><i class="icon-user"></i></span>
      </div>
      <input type="text" class="form-control" formControlName = "email" placeholder="{{'resetemailpage.TranslationSection.text3' | translate}}" autocomplete="email" required>
    </div>
 
    <div class="row">
      <div class="col-10">
        <button matStepperPrevious type="button" style="background-color:#005b9d; color:white; width:150px;" class="btn btn-md">{{'resetemailpage.TranslationSection.text5' | translate}}</button>
    <button mat-button matStepperNext type="submit">{{'resetemailpage.TranslationSection.text6' | translate}}</button>
      </div>

    
      <div id="loadimage">
          <img *ngIf="loading" style = "width:40px; height:40px;" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
      </div>
    </div>

  </form>
</div>



<div *ngIf="!hideconfirm">
  <div style="text-align: center">
      <h1> <font color="#005b9d">{{'resetemailpage.TranslationSection.text8' | translate}}</font></h1>
  </div>



  <div class="row">
    <div class="col">  
    
      {{'resetemailpage.TranslationSection.text9' | translate}} <a class="nav-link" href="https://application.premierhomehealthcare.com" value="Sign In" style="color: blue; font-size: medium;">{{'resetemailpage.TranslationSection.text10' | translate}}</a> {{'resetemailpage.TranslationSection.text11' | translate}}

    </div>

  </div>

  </div>

 
